import { render, staticRenderFns } from "./shopStore.vue?vue&type=template&id=55b887f3&scoped=true"
import script from "./shopStore.vue?vue&type=script&lang=js"
export * from "./shopStore.vue?vue&type=script&lang=js"
import style0 from "./shopStore.vue?vue&type=style&index=0&id=55b887f3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b887f3",
  null
  
)

export default component.exports